module.exports = __webpack_public_path__ + "static/ideate@2x-fcb93c33bc9e2798b7af1400a7a95090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/financial-services/ideate@2x.jpg
// module id = 2632
// module chunks = 47877783677342